import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(theme => ({
  formOutLineIcon: {
    color: theme.colors.mainGreen6,
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 'bold',
    '&:hover': {
      cursor: 'pointer',
    },
  },

  cardContainer: {
    marginBottom: 24,
  },

  cardWrapper: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.09)',
    '& .ant-card-body': {
      padding: '0 0 24px',
    },

    '& .ant-card-head': {
      padding: 0,
      border: 'none',
      minHeight: 'auto',

      '& .ant-card-extra': {
        padding: 0,
      },

      '& .ant-card-head-title': {
        padding: 0,
        fontSize: 14,
        lineHeight: '22px',
        color: 'rgba(0, 0, 0, 0.85)',
      },
    },
  },

  modalWrapper: {
    '& .ant-modal-body': {
      padding: '0 32px 8px 32px !important',
    },

    '& .ant-btn-cancel': {
      color: theme.colors.bodyColor,
      borderColor: theme.colors.gray5,
    },

    '& .ant-btn-confirm span': {
      fontWeight: '600 !important',
    },
  },

  formWrapper: {
    '& .ant-legacy-form-item': {
      paddingBottom: 0,

      '& .ant-legacy-form-item-label': {
        fontSize: 14,
        lineHeight: '22px',
        fontWeight: 400,
        marginBottom: 8,

        '&>label': {
          display: 'inline-block',
          color: theme.colors.titleColor,
          textTransform: 'capitalize',
        },
      },

      '& .ant-legacy-form-item-control': {
        lineHeight: 1,
      },
    },
  },

  descriptionWrapper: {
    '& .ant-descriptions-row': {
      '& .ant-descriptions-item:last-child': {
        paddingLeft: 16,
      },
      '& .ant-descriptions-item:first-child': {
        paddingRight: 16,
        paddingLeft: 0,
        paddingBottom: 0,
      },
    },

    '& .ant-descriptions-row:last-child': {
      '& .ant-descriptions-item': {
        paddingBottom: 0,
      },
    },

    '& .ant-descriptions-item': {
      verticalAlign: 'top',
      overflow: 'hidden',

      '& .ant-descriptions-item-label': {
        float: 'left',
        color: 'rgba(0, 0, 0, 0.45) !important',
        lineHeight: '22px',
      },

      '& .ant-descriptions-item-content': {
        wordBreak: 'break-all',
        color: 'rgba(0, 0, 0, 0.45) !important',
        lineHeight: '22px',
      },

      '& .ant-descriptions-item-label, & .ant-descriptions-item-content': {
        display: 'block',
        color: theme.colors.bodyColor,
      },
    },
  },
  city: {
    ...theme.typography.body3,
    fontWeight: 400,
    color: theme.colors.titleColor,
  },
  selectCity: {
    '& .ant-select-selection': {
      '&:hover': {
        cursor: 'text',
      },
    },
    '& .ant-select-selection-selected-value': {
      '& span': {
        color: 'rgba(0, 0, 0, 0.65)',
      },
    },
  },
  country: {
    ...theme.typography.body3,
    fontWeight: 400,
    color: theme.colors.captionColor,
  },
}));

export default useStyles;
